import React, { useState, useEffect } from "react";
import InventoryLotGrid from "./InventoryLotGrid";
import { Button } from "devextreme-react/button";
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { InventoryItemRecord } from "./InventoryItemRecord"
import LocationsPopUp from "../../wm/components/transactions/inventory/LocationsPopUp";
import InventoryItemStatusPopUp from "./InventoryItemStatusPopUp";
import InventorySerialNamberPopUp from "./../../wm/components/transactions/inventory/InventorySerialNamberPopUp";

import { useHistory } from 'react-router-dom';
import Toolbar, { Item } from "devextreme-react/toolbar";

const OMInventoryLotManagment = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dataBase = props.ReceiptReducer.wmTransactionDatabase !== ""
    ? props.ReceiptReducer.wmTransactionDatabase
    : "";
  var accessToken = props.oidc.user.access_token;
  const [stateLocPopUp, setstateLocPopUp] = useState(false);
  const [stateStatusPopUp, setStateStatusPopUp] = useState(false);
  const [stateSerialNumberPopUp, setstateSerialNumberPopUp] = useState(false);
  const [locbtnDisable, setlocbtnDisable] = useState(true);
  const [statusbtnDisable, setStatusbtnDisable] = useState(true);
  const [SerialNumberBtnDisable, setSerialNumberBtnDisable] = useState(true);
  const [stateItemObj, setStateItemObj] = useState({});
  const [inventoryLotCodesData, setinventoryLotCodesData] = useState([]);
  const [inventoryItemCodeObj, setInventoryItemCodeObj] = useState({
    ItemCode: '',
    "Description-1": '',
    "Description-2": '',
    Status: '',
    Class: '',
    SubClass: '',
    itemRowid: location?.state?.detail,
  });
  const [inventoryLotCodesObj, setinventoryLotCodesObj] = useState({
    lotDescription1: "",
    itemDescription1: "",
    customerName: "",
    lotCode: "",
    itemCode: "",
    itemRowid: location?.state?.detail,
    dbName: dataBase
  });
  const handleCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.OM.GetItemByRowid}`, {itemRowid: ChildData.itemRowid},
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        res.data.lotRowid = ChildData.lotRowid;
        setStateItemObj(res.data);
        setlocbtnDisable(false);
        setSerialNumberBtnDisable(false);
        setStatusbtnDisable(false);
      });
  };
  const handlEnableDisableLocBtn = (ChildData) => {
    setlocbtnDisable(ChildData);
  };
  const handlEnableDisableStatusBtn = (ChildData) => {
    setStatusbtnDisable(ChildData);
  };

  const handlEnableDisableSerialNumberBtn = (ChildData) => {
    setSerialNumberBtnDisable(ChildData);
  };
  const handleClosePopUpCallback = (ChildData) => {
    setstateLocPopUp(ChildData);
  };
  const handleStatusPopUpCloseCallback = (ChildData) => {
    setStateStatusPopUp(ChildData);
  };
  const handleSerialNumberClosePopUpCallback = (ChildData) => {
    setstateSerialNumberPopUp(ChildData);
  };
  const openLocations = (e) => {
    if (stateItemObj) {
      setstateLocPopUp(true);
    }
  };
  const openSerialnumberPopUp = (e) => {
    if (stateItemObj) {
      setstateSerialNumberPopUp(true);
    }
  };
  const openStatus = (e) => {
    if (stateItemObj) {
      setStateStatusPopUp(true);
    }
  };
  const loadInventoryLotData = () => {
    axios
      .get(`${window._env_.REACT_APP_APIS}/${data.OM.GetAllLots}?itemRowid=` + inventoryLotCodesObj.itemRowid,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setinventoryLotCodesData(res.data.data);
      });
  };
  const loadItemData = () => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.OM.GetItemByRowid}`, inventoryItemCodeObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setInventoryItemCodeObj(res.data);
      });
  };
  const Back = () => {
    history.push({
      pathname: '/om/Inventory'
    });
    return;
  };
  useEffect(() => {
    loadInventoryLotData();
    loadItemData();
  }, []);

  return (
    <div className="row bg-white">
      <div className="col-md-12">
        <Toolbar>
          <Item location="before">
            <div className="title">
              <h6
                style={{
                  color: window._env_.Color2
                }}
              >
                Lots
              </h6>
            </div>
          </Item>
          <Item location="after">
          <Button onClick={Back} text="Back" icon="back">
          </Button>
          </Item>
        </Toolbar>
      </div>
      <div className="row " style={{ marginLeft: "0px" }}>
        <div className="col-md-12">
          <InventoryItemRecord itemObj={inventoryItemCodeObj}></InventoryItemRecord>
        </div>
      </div>
      <div className="row " style={{ marginLeft: "0px" }}>
        <div className="col-md-12">
        <InventoryLotGrid data={inventoryLotCodesData}
          accessToken={accessToken}
          parentCallback={handleCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          locbtnDisable={locbtnDisable}
          openLocations={openLocations}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
        />
        </div>
      </div>
        
      {stateLocPopUp && (
        <LocationsPopUp
          itemObj={stateItemObj}
          visibility={stateLocPopUp}
          parentCallback={handleClosePopUpCallback}
        ></LocationsPopUp>
      )}
        {stateSerialNumberPopUp && (
        <InventorySerialNamberPopUp
          itemObj={stateItemObj}
          visibility={stateSerialNumberPopUp}
          parentCallback={handleSerialNumberClosePopUpCallback}
        ></InventorySerialNamberPopUp>
      )}
      {stateStatusPopUp && (
        <InventoryItemStatusPopUp
          itemObj={stateItemObj}
          visibility={stateStatusPopUp}
          parentCallback={handleStatusPopUpCloseCallback}
        ></InventoryItemStatusPopUp>
      )}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMInventoryLotManagment);